import { Link } from "react-router-dom";

export const ModernPedagogicalTechnologiesConst = {
  path: "/single-page/modern-pedagogical-technologies",
  title: "СОВРЕМЕННЫЕ ПЕДАГОГИЧЕСКИЕ ТЕХНОЛОГИИ",
  contentJSX: (
    <>
      <h2>СОВРЕМЕННЫЕ ПЕДАГОГИЧЕСКИЕ ТЕХНОЛОГИИ</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн / гибрид</p>
      <p>Язык: русский (по запросу: английский / узбекский)</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. СОВРЕМЕННЫЕ ПОДХОДЫ В ОБРАЗОВАНИИ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Компетентностная модель обучения и педагогический дизайн – 6 ч</li>
        <li>Активные и интерактивные методики: flipped classroom, case-study – 6 ч</li>
        <li>Интеграция междисциплинарных тем и подходов – 6 ч</li>
        <li>Оценивание и обратная связь в современном классе – 6 ч </li>
        <li>Индивидуализация и инклюзивное обучение – 6 ч</li>
      </ul>
      <h2>II. ЦИФРОВИЗАЦИЯ И EDTECH — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Цифровая трансформация образования: тренды и вызовы – 6 ч</li>
        <li>Онлайн-платформы и интерактивные среды: Zoom, Miro, Moodle – 6 ч</li>
        <li>Использование образовательных игр, квизов и визуальных инструментов – 6 ч</li>
        <li>Формирование цифровой грамотности у студентов – 6 ч</li>
        <li>Гибридные форматы и смешанное обучение – 6 ч</li>
      </ul>
      <h2>III. МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО И ИНТЕРНАЦИОНАЛИЗАЦИЯ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Участие в Erasmus+, DAAD, Horizon Europe – 6 ч</li>
        <li>Разработка совместных образовательных проектов и сетевых программ – 6 ч</li>
        <li>Мобильность преподавателей и студентов: возможности и механизмы – 6 ч</li>
        <li>Интеграция интернациональных компонентов в учебные курсы – 6 ч</li>
      </ul>
      <h2>IV. КАЧЕСТВО И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Системы внутреннего и внешнего обеспечения качества – 6 ч</li>
        <li>Антиплагиат, этика, академическая честность – 6 ч</li>
        <li>Стандарты и процедуры аккредитации (нац. и международные) – 6 ч</li>
        <li>Оценка эффективности образовательных программ – 6 ч</li>
      </ul>
      <h2>V. МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ (ДЛЯ ПРЕПОДАВАТЕЛЕЙ МЕДИЦИНСКИХ ФАКУЛЬТЕТОВ) — 18 ЧАСОВ</h2>
      <ul className="number">
        <li>Клинические кейсы и проблемно-ориентированное обучение – 6 ч</li>
        <li>Симуляционное обучение и OSCE-оценивание – 6 ч</li>
        <li>Инновационные подходы в обучении здравоохранению – 6 ч</li>
      </ul>
      <h2>VI. МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Эмоциональный интеллект и стресс-менеджмент – 6 ч</li>
        <li>Саморазвитие и тайм-менеджмент в преподавании – 6 ч</li>
      </ul>
      <h2>VII. АНГЛИЙСКИЙ ЯЗЫК ДЛЯ КАРЬЕРЫ И АКАДЕМИЧЕСКОЙ КОММУНИКАЦИИ — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Академическое письмо, аннотация и презентация проектов – 6 ч</li>
        <li>Коммуникация и преподавание на английском (EMI) – 6 ч</li>
      </ul>
      <h2>VIII. ИННОВАЦИИ И ПРОЕКТНОЕ МЫШЛЕНИЕ В ВЫСШЕМ ОБРАЗОВАНИИ — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Дизайн-мышление и Lean-методологии в образовании – 6 ч</li>
        <li>Проектная деятельность и agile-курсы для студентов – 6 ч</li>
      </ul>
      <h2>IX. ИНДИВИДУАЛЬНЫЙ ИТОГОВЫЙ ПРОЕКТ — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Разработка авторского учебного модуля с элементами EdTech и интернационализации – 6 ч</li>
        <li>Презентация, peer-review и план дальнейшего внедрения – 6 ч</li>
      </ul>
      <p>
        <strong>Дополнительно:</strong>
      </p>
      <ul>
        <li>Консультации с международными кураторами</li>
        <li>Участие в закрытых вебинарах и практикумах</li>
        <li>Поддержка публикационной активности и международных стажировок</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    СОВРЕМЕННЫЕ ПЕДАГОГИЧЕСКИЕ ТЕХНОЛОГИИ
    Общий объём: 144 академических часа
    Формат: онлайн / офлайн / гибрид
    Язык: русский (по запросу: английский / узбекский)
    Итог: Международный сертификат
    I. СОВРЕМЕННЫЕ ПОДХОДЫ В ОБРАЗОВАНИИ — 30 ЧАСОВ
    Компетентностная модель обучения и педагогический дизайн – 6 ч
    Активные и интерактивные методики: flipped classroom, case-study – 6 ч
    Интеграция междисциплинарных тем и подходов – 6 ч
    Оценивание и обратная связь в современном классе – 6 ч
    Индивидуализация и инклюзивное обучение – 6 ч
    II. ЦИФРОВИЗАЦИЯ И EDTECH — 30 ЧАСОВ
    Цифровая трансформация образования: тренды и вызовы – 6 ч
    Онлайн-платформы и интерактивные среды: Zoom, Miro, Moodle – 6 ч
    Использование образовательных игр, квизов и визуальных инструментов – 6 ч
    Формирование цифровой грамотности у студентов – 6 ч
    Гибридные форматы и смешанное обучение – 6 ч
    III. МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО И ИНТЕРНАЦИОНАЛИЗАЦИЯ — 24 ЧАСА
    Участие в Erasmus+, DAAD, Horizon Europe – 6 ч
    Разработка совместных образовательных проектов и сетевых программ – 6 ч
    Мобильность преподавателей и студентов: возможности и механизмы – 6 ч
    Интеграция интернациональных компонентов в учебные курсы – 6 ч
    IV. КАЧЕСТВО И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ — 24 ЧАСА
    Системы внутреннего и внешнего обеспечения качества – 6 ч
    Антиплагиат, этика, академическая честность – 6 ч
    Стандарты и процедуры аккредитации (нац. и международные) – 6 ч
    Оценка эффективности образовательных программ – 6 ч
    V. МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ (ДЛЯ ПРЕПОДАВАТЕЛЕЙ МЕДИЦИНСКИХ ФАКУЛЬТЕТОВ) — 18 ЧАСОВ
    Клинические кейсы и проблемно-ориентированное обучение – 6 ч
    Симуляционное обучение и OSCE-оценивание – 6 ч
    Инновационные подходы в обучении здравоохранению – 6 ч
    VI. МЯГКИЕ НАВЫКИ И РЕСУРСНОСТЬ ПРЕПОДАВАТЕЛЯ — 12 ЧАСОВ
    Эмоциональный интеллект и стресс-менеджмент – 6 ч
    Саморазвитие и тайм-менеджмент в преподавании – 6 ч
    VII. АНГЛИЙСКИЙ ЯЗЫК ДЛЯ КАРЬЕРЫ И АКАДЕМИЧЕСКОЙ КОММУНИКАЦИИ — 12 ЧАСОВ
    Академическое письмо, аннотация и презентация проектов – 6 ч
    Коммуникация и преподавание на английском (EMI) – 6 ч
    VIII. ИННОВАЦИИ И ПРОЕКТНОЕ МЫШЛЕНИЕ В ВЫСШЕМ ОБРАЗОВАНИИ — 12 ЧАСОВ
    Дизайн-мышление и Lean-методологии в образовании – 6 ч
    Проектная деятельность и agile-курсы для студентов – 6 ч
    IX. ИНДИВИДУАЛЬНЫЙ ИТОГОВЫЙ ПРОЕКТ — 12 ЧАСОВ
    Разработка авторского учебного модуля с элементами EdTech и интернационализации – 6 ч
    Презентация, peer-review и план дальнейшего внедрения – 6 ч
    Дополнительно:
    • Консультации с международными кураторами
    • Участие в закрытых вебинарах и практикумах
    • Поддержка публикационной активности и международных стажировок
  `,
};
